export const BLUE="#2563EB",DARK="#0F172A",GOLD="#B8963E",LIGHT="#EFF6FF",BG="#F8FAFC",GREEN="#16A34A",RED="#DC2626",AMBER="#D97706";